






































































import { ValidationObserver } from 'vee-validate'
import { Component, Emit, Prop, PropSync, Watch } from 'vue-property-decorator'

import { warningNotificationWrapper } from '../../../../logic/helpers/NotificationService'
import HelpMessage from '../../../HelpMessage/HelpMessage.vue'
import { UseFields } from '../../../Pi'
import { FieldData, SelectOptionData } from '../../../Pi/types'
import { BotPropertyTypes, getNewPropertyIcon, getPropertyTranslation, sortProperties, extraView } from '../../utils'
import { BotProperty, PropertyFieldType } from './types'

@Component({
  components: {
    HelpMessage,
    ValidationObserver
  },
  methods: {
    extraView
  }
})
export default class CreateNewProperty extends UseFields {
  @Prop() createNewProperty!: (path: string, name: string, parent?: number, data?: Record<string, any> | null) => Promise<Array<BotProperty> | void>

  @Prop({ default: '' }) initName!: string

  @Prop() initType!: PropertyFieldType

  @PropSync('isOpen') modalIsOpen!: boolean

  @Emit('setProperty')
  setProperty(prop: { id: number }): { id: number } {
    return prop
  }

  @Watch('modalIsOpen')
  modalIsOpenWatcher(val: boolean): void {
    if (val && this.initName) {
      this.newPropertyName = this.initName
    }

    if (val && this.initType) {
      this.newPropertyType = this.initType
    }
  }

  newPropertyName = ''

  newPropertyType: PropertyFieldType = PropertyFieldType.String

  propertyData: Record<string, any> | null = null

  template = 0

  creating = false

  modelSetter(arg: FieldData): FieldData {
    arg.setter = (val) => {
      arg.model[arg.key] = val
    }
    return arg
  }

  get context(): this {
    return this
  }

  get typesOptions(): Array<SelectOptionData> {
    return (BotPropertyTypes ?? []).map((property) => {
      return {
        label: getPropertyTranslation(this.$i18n, property.path),
        value: property.path,
        icon: {
          name: getNewPropertyIcon(property.path),
          iconPack: 'material-icons'
        }
      }
    })
  }

  resetFields(): void {
    this.newPropertyName = ''
    this.newPropertyType = PropertyFieldType.String
    this.propertyData = null
    this.modalIsOpen = false
    this.template += 1
  }

  createProperty(): void {

    if (!!this.newPropertyName && !!this.newPropertyType) {
      this.creating = true

      this.createNewProperty(this.newPropertyType, this.newPropertyName, undefined, this.propertyData)
        .then((properties) => {
          if (properties) {
            const props = sortProperties(properties)

            this.setProperty({ id: props[0].id ?? 0 })

            this.resetFields()
          }
        })
        .finally(() => {
          this.creating = false
        })
    } else {
      warningNotificationWrapper(this.$t('warning').toString(), this.$t('fill_data_alert').toString())
    }
  }
}
